import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const USAGE_ERROR = {
  LIMIT_REACHED: "usage_limit_reached",
};

export const usageLimitErrorSchema = z.object({
  error: z.enum([USAGE_ERROR.LIMIT_REACHED]),
  feature: z.string(),
  resetIn: z.date(),
});

export class UsageLimitErrorDto extends createZodDto(usageLimitErrorSchema) {}
